import React from 'react';

import Alert from 'antd/lib/alert';

import { t } from '../../../app/i18n';
import { InfoModal } from '../../../common/modals';

const TermsText = () => (
  <div>
    <p>
      {t(
        'Súhlas so spracovaním osobných údajov: Klient súhlasí s tým, že spoločnosť Peer2Peer, s.r.o.  („prevádzkovateľ portálu") (ďalej „P2P") s ním bude komunikovať prostredníctvom telefonátov,  SMS správ, MMS správ, ak klient poskytol P2P svoje mobilné telefónne číslo,  e-mailom, ak klient poskytol P2P svoju e-mailovú adresu, iným elektronickým spôsobom alebo prostredníctvom poštového styku na adresu klientom uvedenú, pričom obsahom tejto komunikácie môžu byť aj informácie, ktorých obsahom sú osobné údaje klienta ako aj bankové či obchodné tajomstvo. Klient týmto udeľuje súhlas s poskytnutím osobných údajov P2P a ich spracovaním v takom rozsahu v akom sú uvedené v návrhu rámcovej zmluvy, návrhu žiadosti o pôžičku alebo v návrhu zmluvy o pôžičke za účelom vypracovania ponuky služby ako aj k následným marketingovým aktivitám zo strany P2P (ako aj s marketingovou ponukou tretích strán). Súhlas je udelený na dobu 5 rokov od podpisu návrhu rámcovej zmluvy. V prípade vzniku zmluvného vzťahu sa súhlas udeľuje na dobu trvania zmluvného vzťahu s P2P a na obdobie 5 rokov nasledujúcich po ukončení zmluvného vzťahu s P2P. Súhlas so spracovaním osobných údajov možno pred uplynutím tejto doby odvolať doručením písomného oznámenia adresovaného do sídla spoločnosti Peer2Peer, s.r.o.'
      )}
    </p>
    <p>
      {t(
        'Súhlasím, aby v prípade, že mnou zadané osobné údaje nebudú zhodné s údajmi uvedenými v zaslanom doklade totožnosti, príp. v inom zaslanom doklade, je Peer2Peer oprávnený tieto údaje v žiadosti, ako aj v návrhu rámcovej zmluvy, návrhu žiadosti o pôžičku, v návrhu zmluvy o pôžičke, v návrhu dohode o zrážke zo mzdy alebo v kontaktných údajoch administrátorského systému Peer2Peer opraviť v zmysle zaslaného dokladu totožnosti. Súhlas udeľujem najmä na opravu zrejmých chýb v písaní a iných zrejmých nesprávností.'
      )}
    </p>
  </div>
);

export const TermsLabel = () => (
  <InfoModal title={t('Podmienky používania')} text={<TermsText />}>
    <span className="modal-text">
      {t('Súhlasím s')} <a>{t('podmienkami používania')}</a>
    </span>
  </InfoModal>
);

const DeclarationOfCorrectInformationText = () => (
  <p>
    {t(
      'Týmto prehlasujem, že všetky informácie, ktoré som uviedol sú úplné a pravdivé. Zároveň výslovne prehlasujem, že číslo bankového účtu, číslo mobilného telefónu ako aj e-mail sú registrované na moje meno, mám k nim dispozičné práva a som oprávnený s nimi v plnom rozsahu nakladať. V prípade uvedenia neúplných a/alebo nepravdivých údajov zodpovedám za všetku vzniknutú škodu a som si vedomý možnej trestnej zodpovednosti podľa platnej legislatívy.'
    )}
  </p>
);

export const DeclarationOfCorrectInformationLabel = () => (
  <InfoModal
    title={t('Prehlásenie o úplnosti a pravdivosti údajov')}
    text={<DeclarationOfCorrectInformationText />}
  >
    <span className="modal-text">
      <a>{t('Prehlasujem úplnosť a pravdivosť údajov')}</a>
    </span>
  </InfoModal>
);

export const PunctuationAlert = () => (
  <Alert
    message={t(
      'Prosím pri zadávaní údajov používajte diakritiku (mäkčene a dĺžne) - Osobné údaje vyplňte presne podľa Občianskeho preukazu'
    )}
    showIcon
    type="info"
  />
);



// WEBPACK FOOTER //
// ./src/features/onboarding/common/partials.js